import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function AgeGate() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const requestedDestination = params.get("url") || "";
  let destination = "/";
  try {
    const parsed = new URL(requestedDestination);
    if (parsed.protocol === "http:" || parsed.protocol === "https:") destination = parsed.href;
  } catch {
    // Invalid or missing destinations fail closed to the public site.
  }

  const continueToDestination = () => {
    window.location.assign(destination);
  };

  return (
    <div className="App">
      <Header />
      <main className="xs-page">
        <div className="xs-container" style={{ maxWidth: 620, textAlign: "center" }}>
          <h1 style={{ color: "#ffde16" }}>leaving xaelserpent.com</h1>
          <p>
            You are leaving xaelserpent.com for an entirely different style of content. You must verify that you acknowledge this and that you are the legal age to consume such content.
          </p>
          <div style={{ display: "flex", justifyContent: "center", gap: 12, flexWrap: "wrap", marginTop: 24 }}>
            <button type="button" className="xs-btn primary" onClick={continueToDestination}>Yes</button>
            <button type="button" className="xs-btn ghost" onClick={() => nav("/")}>No</button>
          </div>
        </div>
      </main>
      <Footer show />
    </div>
  );
}
